/* Shared by unassigned brand prototypes. Existing facets/sort still own the listing. */
(() => {
  const guide = document.querySelector('.be-elujuda-guide');
  if (!guide || guide.dataset.interactive) return;
  guide.dataset.interactive = 'true';
  const cards = [...guide.querySelectorAll('[data-guide-products]')];
  const status = guide.querySelector('.be-elujuda-guide__status');
  let selected = null;
  const counts = new WeakMap();
  const facetOriginals = new WeakMap();
  const facetData = JSON.parse(guide.querySelector('[data-guide-facet-data]')?.textContent || '{}');
  const updateFacetCounts = visibleHandles => {
    listing.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach(input => {
      // Deep Layer category totals belong to the existing asynchronous counter.
      // Skip both applying AND restoring them to avoid competing observer writes.
      if (guide.dataset.guideSkipCategoryCounts === 'true' && input.name === 'filter.p.m.custom.categories') return;
      const label = input.closest('label, .facets__label');
      if (!label) return;
      const nodes = [...label.querySelectorAll('.facet-checkbox__text > span:last-child, .visually-hidden > span')];
      if (!nodes.length) return;
      if (!facetOriginals.has(input)) facetOriginals.set(input, {
        disabled: input.disabled, labelDisabled: label.classList.contains('disabled'),
        texts: nodes.map(node => node.textContent)
      });
      const original = facetOriginals.get(input);
      if (!selected) {
        nodes.forEach((node,i) => {if(node.textContent !== original.texts[i]) node.textContent = original.texts[i];});
        input.disabled = original.disabled;
        label.classList.toggle('disabled', original.labelDisabled);
        return;
      }
      if (!visibleHandles.every(handle => Object.hasOwn(facetData[handle] || {}, input.name))) return;
      const count = visibleHandles.filter(handle => {
        const value = facetData[handle]?.[input.name];
        const values = Array.isArray(value) ? value : [value];
        return values.some(value => String(value) === input.value);
      }).length;
      nodes.forEach(node => {
        const text = node.closest('.visually-hidden') ? `${count}アイテム` : String(count);
        if(node.textContent !== text) node.textContent = text;
      });
      input.disabled = count === 0 && !input.checked;
      label.classList.toggle('disabled', input.disabled);
    });
  };
  const listing = document.querySelector('#ProductGridContainer')?.closest('.shopify-section');
  if (!listing) return;
  const prototypeView = new URLSearchParams(location.search).get('view');
  const preserveView = () => {
    if (!prototypeView) return;
    listing.querySelectorAll('form').forEach(form => {
      if (form.querySelector('[name="view"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'view';
      input.value = prototypeView;
      form.append(input);
    });
  };
  preserveView();
  const apply = () => {
    preserveView();
    const handles = selected ? selected.dataset.guideProducts.split(',') : null;
    const grid = listing.querySelector('#product-grid');
    let visible = 0;
    const visibleHandles = [];
    grid?.querySelectorAll(':scope > li').forEach(item => {
      const link = item.querySelector('a[href*="/products/"]');
      const handle = link ? new URL(link.href, location.origin).pathname.split('/products/')[1]?.split('/')[0] : '';
      const show = !handles || handles.includes(handle);
      item.classList.toggle('be-elujuda-guide-hidden', !show);
      if (show) {visible++; visibleHandles.push(handle);}
    });
    listing.querySelectorAll('#ProductCountDesktop, #ProductCount, [data-be-tag-result-count]').forEach(el => {
      const saved = counts.get(el);
      if (!saved || el.textContent !== saved.applied) counts.set(el, {original: el.textContent});
      const state = counts.get(el);
      const text = selected ? `${visible}アイテム` : state.original;
      if (el.textContent !== text) el.textContent = text;
      state.applied = text;
    });
    updateFacetCounts(visibleHandles);
    const message = selected
      ? `${selected.getAttribute('aria-label')}：${visible}アイテム。もう一度カードを押すと解除できます。`
      : 'カードを選ぶと対応商品を表示します。もう一度押すと解除できます。';
    if (status.textContent !== message) status.textContent = message;
  };
  const choose = card => {
    selected = selected === card ? null : card;
    cards.forEach(item => item.setAttribute('aria-pressed', String(item === selected)));
    apply();
    const target = listing.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({top: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  };
  cards.forEach(card => {
    card.addEventListener('click', () => choose(card));
    card.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        choose(card);
      }
    });
  });
  // Reapply to freshly rendered cards after the existing AJAX filter/sort or pagination.
  const observer = new MutationObserver(() => {
    observer.disconnect();
    apply();
    observe();
  });
  const observe = () => observer.observe(listing, {childList:true, subtree:true, characterData:true});
  observe();
})();
